'use client';

import dynamic from 'next/dynamic';
import { FC } from 'react';

import { CircularProgress } from 'src/general/components/CircularProgress/CircularProgress';

type Props = {
  data: {
    date: string;
    volume: number;
    close: number;
  }[];
  xAxisTicks: string[];
};

const InvestorShareInfoGraphContent = dynamic(
  () => import('./InvestorShareInfoGraphContent').then((mod) => mod.InvestorShareInfoGraphContent),
  {
    ssr: false,
    loading: () => (
      <div className="flex h-100 items-center justify-center">
        <CircularProgress />
      </div>
    ),
  },
);

export const InvestorShareInfoGraph: FC<Props> = ({ data, xAxisTicks }) => {
  if (!data || data.length === 0) return null;

  return (
    <div className="relative overflow-hidden rounded-xl border border-bor-neu-mut bg-bac-tie1">
      <header className="flex flex-col border-b border-bor-neu-mut bg-bac-tie2 p-4 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="c-fs-h6 font-extrabold">Market data chart (ASX:CMA)</h3>
        <p className="c-fs-body2 text-tex-def-tie3">Past 30 days</p>
      </header>
      <div className="py-5 smp:px-4">
        <InvestorShareInfoGraphContent data={data} xAxisTicks={xAxisTicks} />
      </div>
    </div>
  );
};
